<ng-template #idleModalTemplate>
  <div class="modal">
    <h4 class="modal__text">{{ 'f.idle-alert.title' | translate }}</h4>
    <div class="flex modal__timer">
      <div class="modal__timerBox mb-6">
        <p class="caption">{{ 'f.idle-alert.minutes' | translate }} {{ 'f.idle-alert.seconds' | translate }}</p>
        <h2>{{ countDown | date: 'mm : ss' }}</h2>
      </div>
    </div>
    <p class="modal__text">{{ 'f.idle-alert.text' | translate }}</p>
    <button class="btn btn-primary" (click)="continue()">{{ 'f.idle-alert.button' | translate }}</button>
  </div>
</ng-template>
